module.exports = __webpack_public_path__ + "img/mockup.70bc3c45.png";